import React, { useEffect } from "react";

import { ProductWithoutId } from "@design-controls/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useForm } from "react-hook-form";

import { ProductProfile } from "../../../components/ProductProfile/ProductProfile";
import { useProductStepInfo } from "../../../hooks/useProductStepInfo";

type Props = {
  nextRef: React.RefObject<any>;
};

export const Product: React.FC<Props> = ({ nextRef }) => {
  const { product, storeProduct, setDisabled } = useProductStepInfo();
  const methods = useForm<ProductWithoutId>({
    defaultValues: product,
    mode: "onChange",
    reValidateMode: "onChange",
    resolver: zodResolver(ProductWithoutId),
  });

  const {
    formState: { isValid },
  } = methods;

  useEffect(() => {
    setDisabled(!isValid);
  }, [isValid, setDisabled]);

  return (
    <FormProvider {...methods}>
      <ProductProfile />
      <button
        style={{ display: "none" }}
        ref={nextRef}
        onClick={methods.handleSubmit(storeProduct)}
        type="submit"
      />
    </FormProvider>
  );
};
